import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { pickFilterSearch } from '../../lib/router/itemsSearchSchema';

const EditAssetGroupPage = lazy(() =>
  import('../../pages/items/EditAssetGroupPage').then((m) => ({ default: m.EditAssetGroupPage })),
);

export const Route = createFileRoute('/items/$assetGroupId/edit')({
  validateSearch: (search: Record<string, unknown>) => ({
    selection: typeof search.selection === 'string' ? search.selection : undefined,
    // Entry-point marker. When the admin unconfirmed-groups list links here it
    // sets `from=admin-unconfirmed`, which switches the page into the full
    // confirm/reject/save-draft enrichment flow. The plain /items/{id}/edit URL
    // keeps the regular stepper edit form, even for unconfirmed groups.
    from: typeof search.from === 'string' ? search.from : undefined,
    // The unconfirmed list's filters, packed by encodeUnconfirmedListSearch, so
    // the flow returns to the same filtered list.
    // Optional key, so the other links to this page need not pass it.
    ...(typeof search.list === 'string' ? { list: search.list } : {}),
    ...pickFilterSearch(search),
  }),
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <EditAssetGroupPage />
    </Suspense>
  ),
});
